import { useTranslation } from "react-i18next";

export const useUnauthAgentFaqs = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("AgentFaq-title-1"),
      desc: t("AgentFaq-desc-1"),
    },
    {
      title: t("AgentFaq-title-2"),
      desc: t("AgentFaq-desc-2"),
    },
    {
      title: t("AgentFaq-title-3"),
      desc: t("AgentFaq-desc-3"),
    },
    {
      title: t("AgentFaq-title-4"),
      desc: t("AgentFaq-desc-4"),
    },
    {
      title: t("AgentFaq-title-5"),
      desc: t("AgentFaq-desc-5"),
    },
    // {
    //   title: t("AgentFaq-title-6"),
    //   desc: t("AgentFaq-desc-6"),
    // },
    // {
    //   title: t("AgentFaq-title-7"),
    //   desc: t("AgentFaq-desc-7"),
    // },
    // {
    //   title: t("AgentFaq-title-8"),
    //   desc: t("AgentFaq-desc-8"),
    // },
    // {
    //   title: t("AgentFaq-title-9"),
    //   desc: t("AgentFaq-desc-9"),
    // },
    {
      title: t("AgentFaq-title-10"),
      desc: t("AgentFaq-desc-10"),
    },
    {
      title: t("AgentFaq-title-11"),
      desc: t("AgentFaq-desc-11"),
    },
    {
      title: t("AgentFaq-title-16"),
      desc: t("AgentFaq-desc-27"),
    },
  ];
};
